/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    export class SelectLinkRoomDialog extends NoboxEntityDialog<LeadRow, any> {
        protected getFormKey() { return Chat.SelectLinkRoomForm.formKey; }
        protected getIdProperty() { return LeadRow.idProperty; }
        protected getLocalTextPrefix() { return LeadRow.localTextPrefix; }
        protected getNameProperty() { return LeadRow.nameProperty; }
        protected getService() { return LeadService.baseUrl; }
        protected getDeletePermission() { return LeadRow.deletePermission; }
        protected getInsertPermission() { return LeadRow.insertPermission; }
        protected getUpdatePermission() { return LeadRow.updatePermission; }

        protected form = new Chat.SelectLinkRoomForm(this.idPrefix);
        public IdLink: number;
        public callback = (response) => {

        }
        protected getDialogTitle() {
            return "Select Contact";
        }
        protected updateLink() {
            var $form = this.form;
            var $this = this;
            Q.serviceCall({
                blockUI: false,
                request: {
                    EntityId: this.IdLink,
                    Entity: {
                        CtId: $form.ContactId.value
                    }
                },
                url: "/Services/Chat/Chatlinkcontacts/Update",
                onSuccess: function (response) {
                    $this.callback({
                        Id: $form.ContactId.value,
                        Name: $form.Name.value,
                        Country: $form.Country.value,
                        State: $form.State.value,
                        City: $form.City.value,
                        Address: $form.Address.value,
                        ZipCode: $form.ZipCode.value,
                        LinkId: $form.LinkId.value,
                        Profil: $form.Image.value == null ? null : $form.Image.value
                    });
                    $this.dialogClose();
                }
            })
        }
        protected getToolbarButtons() {
            var buttons = [] as Serenity.ToolButton[];
            buttons.push({
                title: "Apply",
                icon: "fa-check text-blue",
                onClick: () => {
                    if (this.validateForm()) {
                        this.updateLink();
                    }
                }
            });
            return buttons;
        }
        constructor(container?: JQuery) {
            super(container);
            var $form = this.form;
            $(".s-SelectChatcontactsDialog").children("div.ui-dialog-titlebar").find("span").text("Select Contact");
            this.form.ContactId.change(() => {
                var val = this.form.ContactId.get_value();
                if (!Q.isEmptyOrNull(val)) {
                    Q.serviceCall({
                        blockUI: false,
                        request: {
                            EntityId: val
                        },
                        url: "/Services/Nobox/Contact/Retrieve",
                        onSuccess: function (response) {
                            var res = response.Entity as LeadRow;
                            Serenity.EditorUtils.setValue($form.Name, res.Name);
                            Serenity.EditorUtils.setValue($form.Image, res.Photo);
                            Serenity.EditorUtils.setValue($form.ListId, res.ListId);
                            Serenity.EditorUtils.setValue($form.Notes, res.Notes);
                            Serenity.EditorUtils.setValue($form.Country, res.Country);
                            Serenity.EditorUtils.setValue($form.State, res.State);
                            Serenity.EditorUtils.setValue($form.City, res.City);
                            Serenity.EditorUtils.setValue($form.ZipCode, res.Postal);
                            Serenity.EditorUtils.setValue($form.Address, res.Address);
                        }
                    })
                } else {
                    Serenity.EditorUtils.setValue($form.Name, null);
                    Serenity.EditorUtils.setValue($form.Image, null);
                    Serenity.EditorUtils.setValue($form.ListId, null);
                    Serenity.EditorUtils.setValue($form.Notes, null);
                    Serenity.EditorUtils.setValue($form.Country, null);
                    Serenity.EditorUtils.setValue($form.State, null);
                    Serenity.EditorUtils.setValue($form.City, null);
                    Serenity.EditorUtils.setValue($form.ZipCode, null);
                    Serenity.EditorUtils.setValue($form.Address, null);
                }
            })
        }

        protected updateInterface() {
            super.updateInterface();
            var $form = this.form;
        }

        protected onSaveSuccess(response) {
            super.onSaveSuccess(response);
            this.dialogClose();
        }
    }
}